import { ComponentBase, component } from "@sygnal/sse-core";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

@component("section-reveal")
export class SectionReveal extends ComponentBase {
  protected onPrepare(): void {}

  protected async onLoad(): Promise<void> {
    const el = this.element;
    const ds = el.dataset;

    const animType = ds.animate ?? "fade-up";
    const duration = parseFloat(ds.duration ?? "0.8");
    const delay = parseFloat(ds.delay ?? "0");
    const distance = parseFloat(ds.distance ?? "40");
    const stagger = ds.stagger === "true";

    const targets = stagger ? Array.from(el.children) : [el];

    const fromVars: gsap.TweenVars = { opacity: 0 };
    if (animType === "fade-up")    fromVars.y = distance;
    if (animType === "fade-down")  fromVars.y = -distance;
    if (animType === "fade-left")  fromVars.x = distance;
    if (animType === "fade-right") fromVars.x = -distance;

    gsap.set(targets, fromVars);

    ScrollTrigger.create({
      trigger: el,
      start: "top 85%",
      once: true,
      onEnter: () => {
        gsap.to(targets, {
          opacity: 1,
          x: 0,
          y: 0,
          duration,
          delay,
          ease: "power2.out",
          stagger: stagger ? 0.1 : 0,
        });
      },
    });
  }
}
